import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import usePlaidLink from 'Hooks/usePlaidLink';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import PXTextModalWrapper from '../../PXTextModalWrapper/Layout';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const isClosingRef = React.useRef(null);

  const {
    handleClick,
  } = usePlaidLink({
    plaidTokenLink: resource.relationship(fr.relationships.plaidLink.name).link('related').url(),
  });

  // when a modal opens, it makes changes to the style of body tag. When Plaid opens, it also makes changes to the style of body tag.
  // if Plaid opens from a modal, then the plaid uses the body style the modal had.
  // this causes a bug that after syncing with plaid, we lose the ability to scroll on the page that we launched this modal from.
  // because modals change the style of body so you cant scroll and plaid ends up copying that style and applying it on exit.
  // we need to sequence those events as they both change the DOM (style on body) independently of one another.
  // we are immediately closing the modal when you click continue, which will trigger this component dismounting (with isClosingRef set to true)
  // when that happens, we then allow Plaid to open its modal through "handleClick".
  React.useEffect(() => {
    return () => {
      if (isClosingRef.current === true) {
        handleClick();
      }
    };
  }, [handleClick]);

  const handleOnContinue = () => {
    isClosingRef.current = true;
    clearModalCollection();
  };

  return (
    <PXTextModalWrapper submitOverride={handleOnContinue} />
  );
};

export default Layout;
